import { z } from 'zod';
import { idSchema, platformSchema } from './common.js';
export const analyticsRange = z.enum(['7d', '30d', '90d', 'ytd']);
export const summaryMetric = z.object({
    label: z.string(),
    value: z.string(),
    delta: z.string(),
    up: z.boolean(),
});
export const summaryResponse = z.object({
    summary: z.array(summaryMetric),
});
export const platformBreakdown = z.object({
    platform: platformSchema,
    impressions: z.number().int(),
    engagement: z.number(),
    posts: z.number().int(),
    followers: z.number().int(),
});
export const topPost = z.object({
    id: idSchema,
    title: z.string(),
    platform: platformSchema,
    impressions: z.number().int(),
    engagements: z.number().int(),
    rate: z.number(),
    when: z.string(),
});
export const heatmapResponse = z.object({
    // [day_of_week 0-6][hour 0-23] -> 0..1 normalized engagement
    cells: z.array(z.array(z.number().min(0).max(1))).length(7),
});
export const audienceResponse = z.object({
    age: z.array(z.object({ b: z.string(), p: z.number() })),
    gender: z.array(z.object({ b: z.string(), p: z.number() })),
    geo: z.array(z.object({ b: z.string(), p: z.number() })),
});
//# sourceMappingURL=analytics.js.map